import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;

  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 8px;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  justify-items: start;
  justify-self: start;

  ${mediaQueries.laptop} {
    grid-template-columns: unset;
    grid-template-rows: unset;
    gap: 24px;
  }
`
